'use client'
import { EmptyStateType, EmptyStateProps } from './types'
import { EmptyContentCard } from './EmptyContentCard'
import { EmptyArticles } from './EmptyArticles'
import { EmptyFAQs } from './EmptyFAQs'
import { EventEmptyState } from './EventEmptyState'
import { ProductGroupEmptyState } from './ProductGroupEmptyState'
import { EmptySuccess } from './EmptySuccess'
import { EmptyCard } from './EmptyCard'
import { EmptyProducts } from './EmptyProducts'
import { EmptySolutions } from './EmptySolutions'
import { EmptyProductsAndSolutions } from './EmptyProductsAndSolutions'
import { EmptyFavourites } from './EmptyFavourites'
export type { EmptyStateType, EmptyStateProps }

export const EmptyState: React.FC<EmptyStateProps & { title?: string }> = (props) => {
  const { type, className, button, hasButton, title } = props

  const renderEmptyState = () => {
    const emptyStateProps = { button, hasButton }

    switch (type) {
      case 'content':
        return <EmptyContentCard {...emptyStateProps} />
      case 'articles':
        return <EmptyArticles {...emptyStateProps} />
      case 'faqs':
        return <EmptyFAQs {...emptyStateProps} />
      case 'events':
        return <EventEmptyState {...emptyStateProps} />
      case 'product-groups':
        return <ProductGroupEmptyState {...emptyStateProps} />
      case 'success':
        return <EmptySuccess {...emptyStateProps} />
      case 'card':
        return <EmptyCard {...emptyStateProps} />
      case 'solutions':
        return <EmptySolutions {...emptyStateProps} />
      case 'products':
        return <EmptyProducts {...emptyStateProps} />
      case 'products-and-solutions':
        return <EmptyProductsAndSolutions {...emptyStateProps} />
      case 'favourites':
        return <EmptyFavourites {...emptyStateProps} title={title} />
      default:
        return null
    }
  }

  return <div className={className}>{renderEmptyState()}</div>
}
